<template>
  <el-card style="width: 100%">
    <div
      slot="header"
      class="clearfix"
    >
      <span>Neta - ügynöki</span>
    </div>
    <div class="filter-container">
      <el-form
        label-position="top"
      >
        <el-row :gutter="20">
          <el-col :span="20" style="display: flex; ">
            <el-form-item
              label="Dátum"
            >
              <el-date-picker
                v-model="dateRange"
                type="daterange"
                :clearable="false"
                format="yyyy. MM. dd."
                value-format="yyyy-MM-dd"
                :picker-options="dateRangeOptions"
                style="margin-right: 10px;"
                @change="handleDateChange"
              />
            </el-form-item>
            <el-form-item style="margin-right: 10px;"
                          label="Termék"
            >
              <el-select
                v-model="product"
                filterable
                remote
                :remote-method="searchProduct"
                :loading="productLoading"
                placeholder="Gépelj a kereséshez..."
                style="width: 100%;"
                value-key="id"
                @change="fetchData"
                clearable
              >
                <el-option
                  v-for="p in products"
                  :key="p.id"
                  :value="p"
                  :label="p.name"
                />
              </el-select>
            </el-form-item>
            <el-form-item
              label="Beszállító"
            >
              <el-select
                v-model="partner"
                filterable
                remote
                :remote-method="searchPartner"
                :loading="partnerLoading"
                placeholder="Gépelj a kereséshez..."
                style="width: 100%;"
                value-key="id"
                @change="fetchData"
                clearable
              >
                <el-option
                  v-for="p in partners"
                  :key="p.company.id"
                  :value="p"
                  :label="p.company.name"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <div style="text-align: right; margin-top: 24px;">
              <el-button
                :loading="downloadLoading"
                icon="el-icon-download"
                @click="download"
              >
                Letöltés
              </el-button>
            </div>
          </el-col>
        </el-row>
      </el-form>
    </div>

    <div v-loading="loading">
      <el-table
        :key="tableKey"
        :data="data.data"
        style="width: 100%"
        row-key="id"
        border
      >
        <el-table-column
          width="60"
          prop="count"
          label="#"
          fixed
        >
          <template slot-scope="scope">
            {{ scope.row.product_id }}
          </template>
        </el-table-column>
        <el-table-column
          prop="count"
          label="Termék"
          show-overflow-tooltip
          fixed
        >
          <template slot-scope="scope">
            {{ scope.row.product_name }}
          </template>
        </el-table-column>

        <el-table-column
          width="200"
          prop="count"
          label="Beszállító"
          align="left"
          fixed
          show-overflow-tooltip
        >
          <template slot-scope="scope">
            {{ scope.row.supplier_name }}
          </template>
        </el-table-column>

        <el-table-column label="Bekerülés">
          <el-table-column
            width="100"
            prop="daily_stock"
            label="Nyitó"
            align="right"
          >
            <template slot-scope="scope">
              {{ scope.row.daily_stock }}
            </template>
          </el-table-column>

          <el-table-column
            width="200"
            prop="representative_order_stock"
            label="Raktárközi megrendelés"
            align="right"
          >
            <template slot-scope="scope">
              {{ scope.row.representative_order_stock }}
            </template>
          </el-table-column>

          <el-table-column
            width="200"
            prop="representative_order_stock"
            label="Sztornózott kihelyezés"
            align="right"
          >
            <template slot-scope="scope">
              {{ scope.row.representative_placement_cancel_stock }}
            </template>
          </el-table-column>

          <el-table-column
            width="200"
            prop="representative_order_stock"
            label="Készletátadás"
            align="right"
          >
            <template slot-scope="scope">
              {{ scope.row.representative_receive_stock}}
            </template>
          </el-table-column>
          <el-table-column
            width="200"
            prop="stock_taking_in_stock"
            label="Leltártöbblet"
            align="right"
          >
            <template slot-scope="scope">
              {{ scope.row.stock_taking_in_stock}}
            </template>
          </el-table-column>
        </el-table-column>

        <el-table-column label="Kikerülés">
          <el-table-column
            width="150"
            prop="representative_drop_stock"
            label="Termék leadás"
            align="right"
          >
            <template slot-scope="scope">
              {{ scope.row.representative_drop_stock }}
            </template>
          </el-table-column>

          <el-table-column
            width="100"
            prop="representative_placement_stock"
            label="Kihelyezés"
            align="right"
          >
            <template slot-scope="scope">
              {{ scope.row.representative_placement_stock }}
            </template>
          </el-table-column>

          <el-table-column
            width="160"
            prop="representative_sale_stock"
            label="Kép. eladás (kp)"
            align="right"
          >
            <template slot-scope="scope">
              {{ scope.row.representative_sale_cash_stock }}
            </template>
          </el-table-column>

          <el-table-column
            width="160"
            prop="representative_sale_stock"
            label="Kép. eladás (utalás)"
            align="right"
          >
            <template slot-scope="scope">
              {{ scope.row.representative_sale_transfer_stock }}
            </template>
          </el-table-column>

          <el-table-column
            width="200"
            prop="representative_order_stock"
            label="Készletátadás"
            align="right"
          >
            <template slot-scope="scope">
              {{ scope.row.representative_transfer_stock}}
            </template>
          </el-table-column>
          <el-table-column
            width="200"
            prop="stock_taking_in_stock"
            label="Leltárthiány"
            align="right"
          >
            <template slot-scope="scope">
              {{ scope.row.stock_taking_out_stock}}
            </template>
          </el-table-column>

          <el-table-column
            width="100"
            prop="closing_daily_stock"
            label="Záró"
            align="right"
          >
            <template slot-scope="scope">
              {{ scope.row.closing_daily_stock }}
            </template>
          </el-table-column>
        </el-table-column>


      </el-table>

      <div class="el-card-footer">
        <el-pagination
          background
          :current-page="currentPage"
          :page-sizes="[20, 50, 100, 200]"
          :page-size="parseInt(data.per_page)"
          layout="total, prev, pager, next"
          :total="data.total"
          @current-change="handleCurrentChange"
        />
      </div>
    </div>
  </el-card>
</template>

<script>
import moment from 'moment';
import { saveAs } from 'file-saver';


export default {
  components: {},
  data() {
    const start = moment()
      .startOf('year')
      .format('Y-MM-DD');
    const end = moment()
      .format('Y-MM-DD');
    return {
      tableKey: 0,
      data: {},
      loading: false,
      productLoading: false,
      partnerLoading: false,
      downloadLoading: false,
      product: null,
      products: [],
      partner: null,
      partners: [],
      currentPage: 1,
      dateRange: [start, end],
      dateRangeOptions: {
        firstDayOfWeek: 1,
        shortcuts: [{
          text: 'Aktuális hét',
          onClick(picker) {
            const start = moment()
              .weekday(1)
              .toDate();
            const end = moment()
              .weekday(7)
              .toDate();
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: 'Előző hét',
          onClick(picker) {
            const start = moment()
              .subtract({ weeks: 1 })
              .weekday(1)
              .toDate();
            const end = moment()
              .subtract({ weeks: 1 })
              .weekday(7)
              .toDate();
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: 'Aktuális hónap',
          onClick(picker) {
            const start = moment()
              .startOf('month')
              .toDate();
            const end = moment()
              .endOf('month')
              .toDate();
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: 'Előző hónap',
          onClick(picker) {
            const start = moment()
              .subtract({ months: 1 })
              .startOf('month')
              .toDate();
            const end = moment()
              .subtract({ months: 1 })
              .endOf('month')
              .toDate();
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: 'Előző 3 hónap',
          onClick(picker) {
            const start = moment()
              .subtract({ months: 3 })
              .startOf('month')
              .toDate();
            const end = moment()
              .subtract({ months: 1 })
              .endOf('month')
              .toDate();
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: 'Aktuális év',
          onClick(picker) {
            const start = moment()
              .startOf('year')
              .toDate();
            const end = moment()
              .endOf('year')
              .toDate();
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: 'Előző év',
          onClick(picker) {
            const start = moment()
              .subtract({ years: 1 })
              .startOf('year')
              .toDate();
            const end = moment()
              .subtract({ years: 1 })
              .endOf('year')
              .toDate();
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: 'YTD',
          onClick(picker) {
            const start = moment()
              .startOf('year')
              .toDate();
            const end = moment()
              .toDate();
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: 'MTD',
          onClick(picker) {
            const start = moment()
              .startOf('month')
              .toDate();
            const end = moment()
              .toDate();
            picker.$emit('pick', [start, end]);
          }
        }]
      },
    };
  },
  computed: {},
  watch: {},
  async mounted() {
    this.fetchData();
  },
  methods: {
    async download() {
      this.downloadLoading = true;
      try {
        const excel = await axios({
          url: `api/reports/neta/representative/download`,
          method: 'POST',
          responseType: 'blob',
          data: {
            from: this.dateRange[0],
            to: this.dateRange[1],
            supplier_id: this.partner && this.partner.id,
            product_id: this.product && this.product.id
          },
        });
        saveAs(excel, `netarepresentative.xlsx`);
      } catch (e) {
      }
      this.downloadLoading = false;
    },

    async fetchData(page = 1) {
      this.currentPage = page;
      this.loading = true;
      let query = `api/reports/neta/representative?page=${this.currentPage}&from=${this.dateRange[0]}&to=${this.dateRange[1]}&`;

      if (this.partner) {
        query += `supplier_id=${this.partner.id}&`;
      }

      if (this.product) {
        query += `product_id=${this.product.id}`;
      }

      this.data = await axios.get(query);
      this.loading = false;
    },

    handleCurrentChange(val) {
      this.fetchData(val);
    },

    handleDateChange() {
      this.fetchData();
    },

    async searchProduct(query) {
      if (query !== '') {
        this.productLoading = true;
        this.products = await this.$store.dispatch('product/search', '?name=' + query);
        this.productLoading = false;
      }
    },

    async searchPartner(query) {
      if (query !== '') {
        this.partnerLoading = true;
        this.partners = await this.$store.dispatch('partner/search', '?name=' + query + '&is_supplier=true');
        this.partnerLoading = false;
      }
    },
  },
};
</script>
<style lang="scss">
  .stockValue-table {
    .el-table__footer {
      td {
        .cell {
          font-weight: 700;
        }
      }
    }
  }
</style>
